"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var api_base_1 = __importDefault(require("./api_base"));
var api_base_2 = __importDefault(require("../api_base"));
var FeedbackRequestsModes;
(function (FeedbackRequestsModes) {
    FeedbackRequestsModes["HIERARCHY"] = "hierarchy";
    FeedbackRequestsModes["FLATTENED"] = "flattened";
})(FeedbackRequestsModes = exports.FeedbackRequestsModes || (exports.FeedbackRequestsModes = {}));
exports.default = {
    get: function (organizationId, params, facetParams) {
        var query = qs_1.default.stringify(params);
        var facetsQuery = qs_1.default.stringify(facetParams);
        return Promise.all([
            api_base_1.default.get("organizations/" + organizationId + "/feedback_requests?" + query),
            api_base_1.default.get("organizations/" + organizationId + "/feedback_requests/facets?" + facetsQuery),
            api_base_2.default.get("organizations/" + organizationId + "/vocabulary")
        ]).then(function (_a) {
            var report = _a[0], facets = _a[1], vocabulary = _a[2];
            return {
                facets: facets.data.data,
                data: report.data.data,
                totalPages: report.data.meta.total_pages,
                totalRecords: report.data.meta.total_records,
                vocabulary: vocabulary.data.data
            };
        });
    }
};
//# sourceMappingURL=feedback_requests.js.map